import { useState, useRef } from 'react'
import Image from 'next/image'

import * as Styles from './style'
import SharedDropdown from 'shared/components/dropdown'
import { useClickOutside } from 'shared/hooks/useClickOutside'
import { DarkChevron } from 'shared/images'

export interface CustomDropdownProps {
  value: string
  handleChange: (value: string, lockedToken?: any) => void
  options: string[]
  transformValue?: (value: string) => string
  width?: string
  style?: React.CSSProperties
  selectedItemStyle?: React.CSSProperties
  anchor?: 'top' | 'bottom'
}
const CustomDropdown = (props: CustomDropdownProps) => {
  const { value, handleChange, options, transformValue } = props

  const dropDownRef = useRef(null)

  const renderValue = transformValue ? transformValue(value) : value

  const [open, setOpen] = useState(false)
  useClickOutside(dropDownRef, () => setOpen(false), true)

  return (
    <Styles.CdContainer
      ref={dropDownRef}
      onClick={() => setOpen((val) => !val)}
      style={props?.style ? props?.style : {}}
    >
      <Styles.CdHamburgIcon
        style={props?.selectedItemStyle ? props?.selectedItemStyle : {}}
      >
        {renderValue}
      </Styles.CdHamburgIcon>

      <Styles.CdToggleArrow open={open}>
        <Image src={DarkChevron} alt='chevron' width={20} height={8} />
      </Styles.CdToggleArrow>

      {open && (
        <SharedDropdown
          selectedValue={value}
          width='116px'
          height='175px'
          options={options}
          onOptionClick={(value) => {
            setOpen(false)
            handleChange(value)
          }}
        />
      )}
    </Styles.CdContainer>
  )
}

export default CustomDropdown
